'use client'

import { AntdRegistry } from '@ant-design/nextjs-registry'
import '@ant-design/v5-patch-for-react-19'
import { App, ConfigProvider } from 'antd'
import { unstableSetRender } from 'antd'
import ru_RU from 'antd/lib/locale/ru_RU'

import { PropsWithChildren } from 'react'

import { createRoot } from 'react-dom/client'

import { globalStyles } from 'shared/config/styles/globalStyles'

import './styles.css'

unstableSetRender((node, container) => {
  // @ts-ignore
  container._reactRoot ||= createRoot(container)
  // @ts-ignore
  const root = container._reactRoot
  root.render(node)
  return async () => {
    await new Promise(resolve => setTimeout(resolve, 0))
    root.unmount()
  }
})

export function AntProvider({ children }: PropsWithChildren) {
  return (
    <AntdRegistry>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: 'Nunito, sans-serif',
            lineHeight: 1.42857,
            borderRadius: 8,
          },
          components: {
            Tag: {
              borderRadius: 12,
              borderRadiusSM: 12,
              margin: 0,
            },
            Form: {
              marginLG: 0,
            },
            Table: {
              headerBorderRadius: 3,
            },
            Input: {
              controlHeight: 44,
              controlHeightLG: 48,
              controlHeightSM: 36,
              colorBorder: 'transparent',
              borderRadius: 16,
              borderRadiusSM: 16,
              lineWidthFocus: 0,
              borderRadiusLG: 16,
              fontSize: 14,
              colorBgContainer: globalStyles['--input-primary-default'],
              colorPrimary: globalStyles['--input-primary-default'],
              colorTextPlaceholder: '#55556a', // заменить из палитры
              hoverBorderColor: globalStyles['--stroke-active'],
            },

            Menu: {},
            Segmented: {
              controlHeight: 36,
              borderRadius: 12,
              borderRadiusSM: 10,
            },
            Typography: {
              lineHeightHeading5: 1.4,
              fontWeightStrong: 700,
              titleMarginBottom: 0,
            },
            Card: {
              borderRadiusLG: 16,
            },
            DatePicker: {
              controlHeight: 48,
              controlHeightLG: 48,
              controlHeightSM: 36,
              borderRadius: 16,
              borderRadiusSM: 16,
              borderRadiusLG: 16,
              colorBorder: 'transparent',
              fontSize: 16,
              fontWeightStrong: 500,
              colorPrimary: globalStyles['--input-primary-default'],
              colorBgTextActive: globalStyles['--input-primary-default'],
              colorTextPlaceholder: globalStyles['--text-secondary'],
              colorBgContainer: globalStyles['--input-primary-default'],
            },
            Button: {
              controlHeightSM: 36,
              controlHeight: 44,
              controlHeightLG: 56,

              borderRadius: 12,
              borderRadiusLG: 16,
              borderRadiusSM: 12,

              fontWeight: 500,

              defaultBg: 'rgb(219,234,254)',
              defaultColor: 'rgb(37,99,235)',
              defaultBorderColor: 'rgb(219,234,254)',

              yellow1: 'red',
            },
            Modal: {
              titleFontSize: 20,
              titleLineHeight: 1.4,
            },
            Select: {
              controlHeight: 44,
              borderRadius: 12,
              fontSizeIcon: 20,
              controlHeightSM: 32,
              borderRadiusSM: 12,
            },
            Drawer: {
              padding: 0,
              colorBgMask: 'rgba(9, 9, 22, 0.4)',
              colorBgElevated: 'transparent',
              paddingLG: 0,
            },
          },
        }}
        locale={ru_RU}
      >
        <App>{children}</App>
      </ConfigProvider>
    </AntdRegistry>
  )
}
